import { db } from "./firebase";

/*

    CLIENT DATABASE FUNCTIONS

*/

//Create Client
export const doCreateClient = (
  cUID,
  clientKey,
  email,
  name,
  role,
  userCount,
  siteId,
  apiKey
) =>
  db.ref(`clients/${cUID}`).set({
    clientKey,
    profile: { name, email, position: "", notes: "", phone: "" },
    role,
    status: "active",
    userCount,
    cUID,
    siteId,
    apiKey
  });
export const doCreateClientUser = (cUID, uUID, email, name, role) =>
  db.ref(`clients/${cUID}/users/${uUID}`).set({
    profile: { name, email, position: "", notes: "", phone: "" },
    role,
    status: "active",
    client: cUID,
    uUID
  });
export const doCreateUnassignedUser = (cUID, name, email) =>
  db.ref(`unassignedUsers/${cUID}`).set({ name, email, role: "unassigned" });

//Read Client
export const onceGetClient = cUID =>
  db.ref(`clients/${cUID}`).once("value", snapshot => snapshot);
export const onceGetClientUsers = cUID =>
  db.ref(`clients/${cUID}/users`).once("value", snapshot => snapshot);
export const onceGetClients = () =>
  db.ref(`clients/`).once("value", snapshot => snapshot);

//Update Client
export const doUpdateClientUserStatus = (cUID, uUID, status) =>
  db.ref(`clients/${cUID}/users/${uUID}`).update({ status });
export const doUpdateClientProfile = (cUID, payload) =>
  db.ref(`clients/${cUID}/profile`).update({ ...payload });
/*

    USER DATABASE FUNCTIONS

*/
//Create User
export const doCreateUser = (cUID, uUID, email, name, role, siteId, apiKey) =>
  db.ref(`users/${uUID}`).set({
    client: cUID,
    uUID,
    profile: { name, email, position: "", notes: "", phone: "" },
    role,
    status: "active",
    siteId,
    apiKey
  });

//Read User
export const onceGetUser = uUID =>
  db.ref(`users/${uUID}`).once("value", snapshot => snapshot);
export const onceGetUsers = () =>
  db.ref(`users/`).once("value", snapshot => snapshot);
export const onceGetUserData = (uUID, data) =>
  db.ref(`users/${uUID}/${data}`).once("value", snapshot => snapshot);

//Update User
export const doUpdateUserProfile = (uUID, client, payload) =>
  db.ref(`clients/${client}/users/${uUID}/profile`).update({ ...payload });
export const updateUserCount = (cUID, value) =>
  db.ref(`clients/${cUID}/`).update({ userCount: value });

//Logout
export const doRemoveListeners = () => db.ref().off();

/*

  DB WATCHERS

*/
//Track User

//Toggle user status
export const watchClientUsers = cUID =>
  db.ref(`clients/${cUID}/users`).on("value", snapshot => {
    try {
      const value = snapshot.val();
      db.ref(`users`).update({ ...value });
    } catch (err) {
      console.log(err);
    }
  });

//Update profile
export const watchClientProfile = cUID =>
  db.ref(`clients/${cUID}/profile`).on("value", snapshot => {
    try {
      const value = snapshot.val();
      db.ref(`users/${cUID}/profile`).update({ ...value });
    } catch (err) {
      console.log(err);
    }
  });

export const watchUserProfile = (cUID, uUID) => {
  db.ref(`clients/${cUID}/users/${uUID}/profile`).on("value", snapshot => {
    try {
      const value = snapshot.val();
      db.ref(`users/${uUID}/profile`).update({ ...value });
    } catch (err) {
      console.log(err);
    }
  });
};



// WEBPACK FOOTER //
// ./src/firebase/db.js